import JsonApi from "./jsonApi";
import {getSessionStorageItem, setSessionStorageItem} from "../misc/storageFunctions";
import {renderErrorPopup} from "./api-popups";

export const postLoginAdmin = (data) => {
  return JsonApi.loginAdmin(data)
    .then(response => {
      console.log("loginAdmin response", response);
      if (response && response.status === 200 && response.data) {
        setSessionStorageItem("superAdminToken", response.data);
        return true
      }
      return false
    })
    .catch(error => {
      console.log("Server error postLoginAdmin "+new Error(error));
      return false
    })
};

export const postEditFeatures = (data) => {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": "Bearer " + getSessionStorageItem("superAdminToken", false),
  }
  return JsonApi.postEditFeatures(data, headers)
    .then(response => {
      return response && response.data
    })
    .catch(error => {
      if (error && error.response && error.response.status === 401) {
        renderErrorPopup("Your session is expired, please re-login again");
      } else {
        renderErrorPopup(error);
      }
      console.log("Server error postEditFeatures "+new Error(error));
      return false
    })
}
